import React, { useContext } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import MyContext from "../../../StoreContext";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import { trackHotjar } from "../../../helpers/hotjar";

const CustomToggleButton = styled(ToggleButton)`
  width: 250px;
  height: 40px;
  border: 1px solid #181533;
  border-radius: 10px;
  color: #181533;

  &:hover {
    background-color: rgb(68 60 145 / 10%);
  }

  &.Mui-selected {
    background-color: #443b91;
    color: #fff;
  }

  &.Mui-selected:hover {
    background-color: #443b91;
  }
`;

const buttonText = {
  fontSize: "14px",
  fontWeight: "500",
  fontFamily: "Asap",
  lineHeight: "20px",
};

const bankOptions = [
  { name: "max", label: "Monto máximo para transferencias" },
  { name: "blockcard", label: "Bloqueo de tarjeta" },
  { name: "stolen", label: "Robo de tarjeta" },
];

/**
 * Componente que muestar los botones con los mensajes del
 * rubro bank
 */
const BankMessage = () => {
  const { message, updateMessage } = useContext(MyContext);

  const handleChange = (event: any, newSelected: string) => {
    const optionObject = bankOptions.find((o) => o.name === newSelected);
    if (optionObject) {
      trackHotjar(`[Etapa 3] Ha seleccionado ${optionObject.label}`);
    }

    updateMessage(newSelected);
  };

  return (
    <>
      <Stack direction='column' spacing={2}>
        {bankOptions.map((item, i) => {
          return (
            <CustomToggleButton
              key={i}
              value={item.name}
              onClick={handleChange}
              selected={message === item.name}
            >
              <Typography className='toggleMessageButtonText' sx={buttonText}>
                {item.label}
              </Typography>
            </CustomToggleButton>
          );
        })}
      </Stack>
    </>
  );
};

export default BankMessage;
